'use strict';

exports.__esModule = true;
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Futura PT
// ~~~~~ fonts.adobe.com/my_fonts?project_id=jdd4npp#web_projects-section
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
var jdd4npp = {
  id: 'jdd4npp',
  paragraphs: {
    fontFamily: 'adobe-garamond-pro, serif',
    lowerFontWeight: 400,
    higherFontWeight: 700,
    range: [13, 22]
  },
  headings: {
    fontFamily: 'futura-pt, sans-serif',
    lowerFontWeight: 400,
    higherFontWeight: 700,
    range: [14, 22]
  },
  metadata: {
    paragraphs: {
      annotation: {
        classification: 'sans-serif',
        recommendations: ['headings'],
        weight: 'heavy',
        width: 'regular',
        xHeight: 'low',
        contrast: 'low',
        standardOrCaps: 'standard',
        defaultFigure: 'uppercase'
      },
      openTypeFeatures: {
        // Refer: https://helpx.adobe.com/typekit/using/open-type-syntax.html
        // Ligatures
        liga: false, // standard ligatures
        calt: false, // contextual alternates
        dlig: false, // discretionary ligatures
        hlig: false, // historical ligatures
        rlig: false, // required ligatures

        // Letters
        smcp: false, // small caps
        c2sc: false, // small capitals from capitals
        swsh: false, // swashes
        salt: false, // swashes

        // Numbers
        lnum: false, // lining figures
        onum: false, // old style figures
        pnum: false, // proportional figures
        tnum: false, // tabular figures
        frac: false, // fractions
        ordn: false, // ordinals

        // Stylistic Sets
        ss: false, // stylistic sets 01-20 (ss##)

        // Vertical Features
        vkern: false,
        vert: false,
        vpal: false,
        vhal: false,
        vkna: false,

        // Others
        zero: false, // slashed zero
        kern: false, // kerning
        sups: false, // superscript
        subs: false, // subscript
        mark: false, // mark
        mkmk: false, // mark-to-mark positioning

        // Forms
        case: false, // case-sensitive forms
        hist: false, // historical forms
        locl: false, // localized forms
        medi: false, // medial forms
        init: false, // initial forms
        isol: false, // isolated forms
        fina: false // final forms
      }
    },
    headings: {
      annotation: {
        classification: 'sans-serif',
        recommendations: ['headings'],
        weight: 'heavy',
        width: 'regular',
        xHeight: 'low',
        contrast: 'low',
        standardOrCaps: 'standard',
        defaultFigure: 'uppercase'
      },
      openTypeFeatures: {
        // Refer: https://helpx.adobe.com/typekit/using/open-type-syntax.html
        // Ligatures
        liga: false, // standard ligatures
        calt: false, // contextual alternates
        dlig: false, // discretionary ligatures
        hlig: false, // historical ligatures
        rlig: false, // required ligatures

        // Letters
        smcp: false, // small caps
        c2sc: false, // small capitals from capitals
        swsh: false, // swashes
        salt: false, // swashes

        // Numbers
        lnum: false, // lining figures
        onum: false, // old style figures
        pnum: false, // proportional figures
        tnum: false, // tabular figures
        frac: false, // fractions
        ordn: false, // ordinals

        // Stylistic Sets
        ss: false, // stylistic sets 01-20 (ss##)

        // Vertical Features
        vkern: false,
        vert: false,
        vpal: false,
        vhal: false,
        vkna: false,

        // Others
        zero: false, // slashed zero
        kern: false, // kerning
        sups: false, // superscript
        subs: false, // subscript
        mark: false, // mark
        mkmk: false, // mark-to-mark positioning

        // Forms
        case: false, // case-sensitive forms
        hist: false, // historical forms
        locl: false, // localized forms
        medi: false, // medial forms
        init: false, // initial forms
        isol: false, // isolated forms
        fina: false // final forms
      }
    }
  }
};

exports.default = jdd4npp;
module.exports = exports['default'];